import { Store } from "lucide-react";

const TileStoreManagerTileDesign = {
  id: "tile-store-manager",
  icon: Store,
  label: "Tile Store Admin",
  background: "#6D8196",
  color: "#ffffff",
};

export default TileStoreManagerTileDesign;
